export default __webpack_public_path__ + "static/media/final-close.54b890ae.svg";